// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__xjAg1","header":"MergedInvoice_header__ocbo7"};